"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var inertia_1 = require("@inertiajs/inertia");
var inertia_react_1 = require("@inertiajs/inertia-react");
var axios_1 = __importDefault(require("axios"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var ActionSection_1 = __importDefault(require("@/Jetstream/ActionSection"));
var Button_1 = __importDefault(require("@/Jetstream/Button"));
var ConfirmsPassword_1 = __importDefault(require("@/Jetstream/ConfirmsPassword"));
var DangerButton_1 = __importDefault(require("@/Jetstream/DangerButton"));
var SecondaryButton_1 = __importDefault(require("@/Jetstream/SecondaryButton"));
function TwoFactorAuthenticationForm() {
    var _a, _b;
    var page = (0, inertia_react_1.usePage)();
    var _c = (0, react_1.useState)(false), enabling = _c[0], setEnabling = _c[1];
    var _d = (0, react_1.useState)(false), disabling = _d[0], setDisabling = _d[1];
    var _e = (0, react_1.useState)(null), qrCode = _e[0], setQrCode = _e[1];
    var _f = (0, react_1.useState)([]), recoveryCodes = _f[0], setRecoveryCodes = _f[1];
    var twoFactorEnabled = enabling && ((_b = (_a = page.props) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.two_factor_enabled);
    function enableTwoFactorAuthentication() {
        setEnabling(true);
        inertia_1.Inertia.post('/user/two-factor-authentication', {}, {
            preserveScroll: true,
            onSuccess: function () { return Promise.all([showQrCode(), showRecoveryCodes()]); },
            onFinish: function () { return setEnabling(false); },
        });
    }
    function showQrCode() {
        return axios_1.default.get('/user/two-factor-qr-code').then(function (response) {
            setQrCode(response.data.svg);
        });
    }
    function showRecoveryCodes() {
        return axios_1.default.get('/user/two-factor-recovery-codes').then(function (response) {
            setRecoveryCodes(response.data);
        });
    }
    function regenerateRecoveryCodes() {
        axios_1.default.post('/user/two-factor-recovery-codes').then(function (response) {
            showRecoveryCodes();
        });
    }
    function disableTwoFactorAuthentication() {
        setDisabling(true);
        inertia_1.Inertia.delete('/user/two-factor-authentication', {
            preserveScroll: true,
            onSuccess: function () { return setDisabling(false); },
        });
    }
    return (react_1.default.createElement(ActionSection_1.default, { title: 'Two Factor Authentication', description: 'Add additional security to your account using two factor authentication.' },
        twoFactorEnabled ? (react_1.default.createElement("h3", { className: "text-lg font-medium text-gray-900" }, "You have enabled two factor authentication.")) : (react_1.default.createElement("h3", { className: "text-lg font-medium text-gray-900" }, "You have not enabled two factor authentication.")),
        react_1.default.createElement("div", { className: "mt-3 max-w-xl text-sm text-gray-600" },
            react_1.default.createElement("p", null, "When two factor authentication is enabled, you will be prompted for a secure, random token during authentication. You may retrieve this token from your phone's Google Authenticator application.")),
        twoFactorEnabled ? (react_1.default.createElement("div", null,
            qrCode ? (react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "mt-4 max-w-xl text-sm text-gray-600" },
                    react_1.default.createElement("p", { className: "font-semibold" }, "Two factor authentication is now enabled. Scan the following QR code using your phone's authenticator application.")),
                react_1.default.createElement("div", { className: "mt-4", dangerouslySetInnerHTML: { __html: qrCode || '' } }))) : null,
            recoveryCodes.length > 0 ? (react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "mt-4 max-w-xl text-sm text-gray-600" },
                    react_1.default.createElement("p", { className: "font-semibold" }, "Store these recovery codes in a secure password manager. They can be used to recover access to your account if your two factor authentication device is lost.")),
                react_1.default.createElement("div", { className: "grid gap-1 max-w-xl mt-4 px-4 py-4 font-mono text-sm bg-gray-100 rounded-lg" }, recoveryCodes.map(function (code) { return (react_1.default.createElement("div", { key: code }, code)); })))) : null)) : null,
        react_1.default.createElement("div", { className: "mt-5" }, twoFactorEnabled ? (react_1.default.createElement("div", null,
            recoveryCodes.length > 0 ? (react_1.default.createElement(ConfirmsPassword_1.default, { onConfirm: regenerateRecoveryCodes },
                react_1.default.createElement(SecondaryButton_1.default, { className: "mr-3" }, "Regenerate Recovery Codes"))) : (react_1.default.createElement(ConfirmsPassword_1.default, { onConfirm: showRecoveryCodes },
                react_1.default.createElement(SecondaryButton_1.default, { className: "mr-3" }, "Show Recovery Codes"))),
            react_1.default.createElement(ConfirmsPassword_1.default, { onConfirm: disableTwoFactorAuthentication },
                react_1.default.createElement(DangerButton_1.default, { className: (0, classnames_1.default)({ 'opacity-25': disabling }), disabled: disabling }, "Disable")))) : (react_1.default.createElement("div", null,
            react_1.default.createElement(ConfirmsPassword_1.default, { onConfirm: enableTwoFactorAuthentication },
                react_1.default.createElement(Button_1.default, { type: "button", className: (0, classnames_1.default)({ 'opacity-25': enabling }), disabled: enabling }, "Enable")))))));
}
exports.default = TwoFactorAuthenticationForm;
